import React from "react";
import {api}  from "../../../package.json";
// reactstrap components
import { Card, CardHeader, Row, Col} from "reactstrap";

const DocCards = (props) => {
   
    return (
            <Col className="mb-2" xl="6">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">{props.title.split(".")[0]} </h3>
                    </div>
                    <div className="col text-right">
                      <a
                        href={api + "/userfiles/" + props.email + "/" + props.link}
                        download
                        target="_blank" 
                        rel="noreferrer"
                      >
                        Open File
                      </a>
                    </div>
                  </Row>
                </CardHeader>
              </Card>
            </Col>
                );
  
            }
            
            export default DocCards;